export default __webpack_public_path__ + "static/media/rocket.858872d1.png";